export * from './Title';
export * from './MainTitle';
export * from './P';
export * from './NumberBullet';
export * from './PLight';
export * from './Hr';
export * from './Heading';
